import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Commercial from "./pages/Commercial";
import Residential from "./pages/Residential";
import Services from "./pages/Services";
import Agents from "./pages/Agents";
import Contact from "./pages/Contact";
import Events from "./pages/Events";
import Admin from "./pages/Admin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/commercial" element={<Commercial />} />
                        <Route path="/residential" element={<Residential />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/agents" element={<Agents />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/admin" element={<Admin />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
